import Api from './index';
import AuthService from 'services/Auth';

class ServicesApi extends Api {
  constructor(restaurantID) {
    const resId = restaurantID || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/services`);
  }
}

export default ServicesApi;
